import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import Sidebar from "./Sidebar"

export default function Layout({ setIsLoggedIn }) {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    setIsLoggedIn(false); 
    navigate("/login"); 
  }

  return (
    // Outer container keeps the gray frame background (neutral-200)
    <div className="flex flex-row bg-neutral-200 h-screen w-screen overflow-hidden">
        <Sidebar onLogout={handleLogout} /> 
        
        {/* flex-1 ensures it fills the exact remaining width, eliminating the right-side sliver bug */}
        <div className="flex-1 h-full bg-neutral-200 overflow-y-auto p-6">
          <Outlet />
        </div>
    </div>
  ) 
}